'use client'
import QRCode from 'react-qr-code'
import { NEXT_PUBLIC_ANDROID_STORE_URL, NEXT_PUBLIC_IOS_STORE_URL } from '@/configs/env'
import { DownloadIcon } from 'lucide-react'
import { NEXT_PUBLIC_PRODUCT_PAGE_URL } from '@/configs/env'
export default function DownloadAppPopover() {
  return (
    <div className="relative group inline-block">
      <button className="flex items-center gap-1.5 text-sm font-medium text-gray-700 hover:text-blue-600 transition-colors">
        <DownloadIcon className="w-4 h-4" />
        TẢI APP
      </button>

      {/* Tooltip Popup */}
      <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
        <div className="bg-white rounded-xl shadow-[0_4px_25px_rgba(0,0,0,0.15)] border border-gray-100 p-5 flex items-center gap-5 w-max relative">
          {/* Mũi tên trỏ lên */}
          <div className="absolute bottom-full left-1/2 -translate-x-1/2 border-[10px] border-transparent border-b-white drop-shadow-sm"></div>

          {/* Left: QR Code */}
          <div className="relative border border-gray-200 p-2 rounded-lg bg-white shrink-0 flex items-center justify-center">
            <QRCode value={NEXT_PUBLIC_PRODUCT_PAGE_URL + '/tai-app'} size={100} level="H" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-1 rounded font-bold text-blue-600 text-[10px] leading-none">
              BXS
            </div>
          </div>

          {/* Right: Info and Buttons */}
          <div className="flex flex-col justify-center text-left">
            <h4 className="text-lg font-bold text-gray-900 mb-1">Tải App BuyXShare</h4>
            <p className="text-sm text-gray-500 mb-4">Quét mã QR để tải</p>

            <div className="flex gap-3">
              <a href={NEXT_PUBLIC_IOS_STORE_URL} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2 rounded font-semibold text-sm hover:bg-blue-700 transition-colors">
                <svg viewBox="0 0 384 512" fill="currentColor" className="w-4 h-4"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" /></svg>
                App Store
              </a>
              <a href={NEXT_PUBLIC_ANDROID_STORE_URL} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-blue-600 text-white px-4 py-2 rounded font-semibold text-sm hover:bg-blue-700 transition-colors">
                <svg viewBox="0 0 512 512" fill="currentColor" className="w-4 h-4"><path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" /></svg>
                Google Play
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
